import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ApiLink } from "../APILink/ApiLink";
import authHeader from "../Auth/authHeader";
import { errorAlert } from "../Components/Alerts";
import JsBarcode from "jsbarcode";
import { FaPrint } from "react-icons/fa";
import QRCode from "react-qr-code";
import {
  InvoiceSQ,
  InvoiceEN,
} from "../OtherData/Dictionary/InvoiceDictionary";
import { useMediaQuery } from "@mui/material";
import PhoneInvoicePage from "./ElectronicInvoice/PhoneInvoicePage";

export default function LinkInvoice(props) {
  const isMobile = useMediaQuery("(max-width:768px)");

  const location = useLocation();
  const headers = authHeader();
  const barcodeRef = useRef(null);
  const tableRef = useRef();

  // const getInvoiceNrFromURL = () => {
  //     const queryParams = new URLSearchParams(location.search);
  //     return queryParams.get('invoiceNR');
  // }
  // const uInvoiceNr = getInvoiceNrFromURL();

  // let link = encodeURI(`http://acctree.net/invoice?invoiceNR=${uInvoiceNr}`);

  const getInvoiceNrFromURL = () => {
    const queryParams = new URLSearchParams(location.search);
    const invoiceNr = queryParams.get("invoiceNR");
    const lang = queryParams.get("lang"); // Merr gjuhën nga URL

    return { invoiceNr, lang }; // Kthe një objekt me të dyja vlerat
  };

  const { invoiceNr: uInvoiceNr, lang: userLang } = getInvoiceNrFromURL(); // Shkruaj të dyja vlerat

  let link = encodeURI(`http://acctree.net/invoice?invoiceNR=${uInvoiceNr}&lang=${userLang}`); // Shto parametrin e gjuhës në link
//   const link = encodeURI(
//     `http://192.168.1.4:3000/invoice?invoiceNR=${uInvoiceNr}&lang=${userLang}`
//   );

  // Përdor userLang për të vendosur të dhënat e faturës
  const invoiceTranslate = userLang === "en" ? InvoiceEN : InvoiceSQ;

  const [companiedDetails, setCompaniesDetails] = useState([]);
  const [transactiondetails, setTransactionDetails] = useState([]);
  const [articleDetails, setArticleDetails] = useState([]);
  const [banksdetails, setBankDetails] = useState([]);

  // const totalAmount0 = (transactiondetails && transactiondetails.length > 0 ? transactiondetails[0].Amount0 : 0).toFixed(2);
  // const totalAmount8 = (transactiondetails && transactiondetails.length > 0 ? transactiondetails[0].Amount8 : 0).toFixed(2);
  // const totalAmount18 = (transactiondetails && transactiondetails.length > 0 ? transactiondetails[0].Amount18 : 0).toFixed(2);

  const totalAmount0 = (
    (transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].Amount0
      : null) || 0
  ).toFixed(2);
  const totalAmount8 = (
    (transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].Amount8
      : null) || 0
  ).toFixed(2);
  const totalAmount18 = (
    (transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].Amount18
      : null) || 0
  ).toFixed(2);

  // const discountAmount = (transactiondetails && transactiondetails.length > 0 ? transactiondetails[0].DiscountAmount : 0);
  // const totali = (transactiondetails && transactiondetails.length > 0 ? transactiondetails[0].Total : 0);
  const discountAmount =
    (transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].DiscountAmount
      : null) || 0;
  const totali =
    (transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].Total
      : null) || 0;

  // const totalAmount = (Number(totalAmount0) + Number(totalAmount8) + Number(totalAmount18));
  // const amountPercent = (((Number(discountAmount) / (Number(discountAmount) + Number(totali)))))

  const totalAmount =
    Number(totalAmount0) + Number(totalAmount8) + Number(totalAmount18);
  const amountPercent =
    Number(totalAmount) * (Number(discountAmount) / Number(totali));

  // const vat8 = (transactiondetails && transactiondetails.length > 0 ? transactiondetails[0].VAT8 : 0).toFixed(2);
  // const vat18 = (transactiondetails && transactiondetails.length > 0 ? transactiondetails[0].VAT18 : 0).toFixed(2);
  const vat8 = (
    (transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].VAT8
      : null) || 0
  ).toFixed(2);
  const vat18 = (
    (transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].VAT18
      : null) || 0
  ).toFixed(2);

  const invoiceNr =
    transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].InvoiceNr
      : 0;
  const fiscalYear =
    transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].FiscalYear
      : 0;
  const actionType =
    transactiondetails && transactiondetails.length > 0
      ? transactiondetails[0].ActionType
      : "";

  const inv = "IND-" + fiscalYear + "-" + invoiceNr;

  const fetchInvoiceDetails = async () => {
    try {
      const response = await axios.get(ApiLink.API_URL + "LinkInvoice", {
        headers,
        params: { uInvoiceNr: uInvoiceNr },
      });
      setCompaniesDetails(response.data.CompanyDetails);
      setTransactionDetails(response.data.TransactionDetails);
      setArticleDetails(response.data.ArticleHistory);
      setBankDetails(response.data.BankDetails);
      console.log(response.data);

      // console.log(response.data.CompanyDetails);
      // console.log(response.data.TransactionDetails);
      // console.log(response.data.CompanyDetails);
      // console.log(response.data.BankDetails);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const handlePrint = () => {
    const table = tableRef.current;
    const tableClone = table.cloneNode(true);
    const printWindow = window.open("", "PrintWindow", "height=400,width=600");
    printWindow.document.write(tableClone.outerHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();

    // Shtoni një event listener për beforeunload që do të shkaktohet kur modaliteti i printimit mbyllet
    window.addEventListener("beforeunload", function () {
      // Bëni refresh të modalitetit të printimit në background
      const newPrintWindow = window.open(
        "",
        "PrintWindow",
        "height=400,width=600"
      );
      newPrintWindow.document.close();
      newPrintWindow.focus();
      newPrintWindow.print();
      newPrintWindow.close();
    });
  };


  useEffect(() => {
    if (barcodeRef.current) {
      JsBarcode(barcodeRef.current, inv, {
        format: "CODE128",
        height: 30, // Lartësia në pikselë
        width: 1.5, // Gjerësia e shiritave
        text: actionType === "IND" ? inv : invoiceNr,
        fontSize: 12,
      });
    }
  }, [inv]);

  useEffect(() => {
    fetchInvoiceDetails();
  }, []);

  return (
    <div>
      {/* <button className="button-15" variant="contained" onClick={handlePrint}>
        <FaPrint /> Print
      </button> */}
      {isMobile && (
        <PhoneInvoicePage
          companiedDetails={companiedDetails}
          invoiceTranslate={invoiceTranslate}
          transactiondetails={transactiondetails}
          articleDetails={articleDetails}
          link={link}
          fiscalYear={fiscalYear}
          actionType={actionType}
          invoiceNr={invoiceNr}
          totalAmount0={totalAmount0}
          totalAmount8={totalAmount8}
          vat8={vat8}
          totalAmount18={totalAmount18}
          vat18={vat18}
          totalAmount={totalAmount}
          amountPercent={amountPercent}
          banksdetails={banksdetails}
          onPrint={handlePrint}
        />
      )}
      <div
        style={{
          display: isMobile ? "none" : "flex", // fsheh në mobile
        }}
      >
        <button className="button-15" variant="contained" onClick={handlePrint}>
          <FaPrint /> Print
        </button>
        <div
          style={{
            display: "block",
            width: "60%",
            height: "auto",
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            className="PrintContent__Container"
            ref={tableRef}
            id="print-root"
            style={{
              width: "100%",
              height: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="PrintContent__Container__div2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "15px",
                paddingRight: "15px",
                height: "auto",
              }}
            >
              <div
                className="PrintContent__Container__div2__logo"
                style={{ width: "300px", height: "150px" }}
              >
                {companiedDetails &&
                companiedDetails.length > 0 &&
                companiedDetails[0]?.CompanyLogo ? (
                  <img
                    src={ApiLink.PHOTO_URL + companiedDetails[0].CompanyLogo}
                    style={{ width: "200px", height: "120px" }}
                    className="printLogo"
                  />
                ) : (
                  <span>No logo available</span>
                )}
              </div>

              <div
                className="PrintContent__Container__div2__data"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  padding: "5px",
                }}
              >
                <label style={{ fontSize: "12px" }}>
                  <b>
                    {invoiceTranslate.seller}:{" "}
                    {companiedDetails && companiedDetails.length > 0
                      ? companiedDetails[0].CompanyName
                      : ""}
                  </b>
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.nui}:{" "}
                  {companiedDetails && companiedDetails.length > 0
                    ? companiedDetails[0].IdentificationNumber
                    : ""}
                </label>
                {companiedDetails &&
                companiedDetails.length > 0 &&
                companiedDetails[0].VATDeclarant != 0 ? (
                  <label style={{ fontSize: "12px" }}>
                    {invoiceTranslate.vatNR}: {companiedDetails[0].VATNumber}
                  </label>
                ) : null}
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.addres}:
                  {companiedDetails && companiedDetails.length > 0
                    ? companiedDetails[0].Address
                    : ""}
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.phone}:
                  {companiedDetails && companiedDetails.length > 0
                    ? companiedDetails[0].PhoneNumbers
                    : ""}
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.email}:
                  {companiedDetails && companiedDetails.length > 0
                    ? companiedDetails[0].Email
                    : ""}
                </label>
              </div>
            </div>
            <hr style={{ margin: "10px" }}></hr>

            <div
              className="PrintContent__Container__div3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingLeft: "10px",
                paddingRight: "10px",
                height: "auto",
              }}
            >
              <div
                className="PrintContent__Container__div3__bleresi"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                }}
              >
                <label style={{ fontSize: "12px" }}>
                  <b>
                    {invoiceTranslate.buyer}:
                    {transactiondetails && transactiondetails.length > 0
                      ? transactiondetails[0].ClientName
                      : ""}
                  </b>
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.nui}:{" "}
                  {transactiondetails && transactiondetails.length > 0
                    ? transactiondetails[0].IdentificationNumber
                    : ""}
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.vatNR}:{" "}
                  {transactiondetails && transactiondetails.length > 0
                    ? transactiondetails[0].VATNumber
                    : ""}
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.city}:
                  {transactiondetails && transactiondetails.length > 0
                    ? transactiondetails[0].Adress
                    : ""}
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.addres}:
                  {transactiondetails && transactiondetails.length > 0
                    ? transactiondetails[0].Adress
                    : ""}
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.phone}:
                  {transactiondetails && transactiondetails.length > 0
                    ? transactiondetails[0].PhoneNumbers
                    : ""}
                </label>
              </div>
              <div
                className="PrintContent__Container__div3__dokumenti"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  padding: "10px",
                }}
              >
                <label style={{ fontSize: "12px" }}>
                  <b>
                    {invoiceTranslate.document}:
                    {transactiondetails.length > 0
                      ? transactiondetails[0].ActionType === "IND"
                        ? "Faturë Shitje"
                        : "Faturë Blerje"
                      : ""}
                  </b>
                </label>
                <label style={{ fontSize: "12px" }}>
                  {" "}
                  <b>{invoiceTranslate.number} : </b>
                  <label style={{ fontSize: "12px" }}>
                    <b>
                      {transactiondetails && transactiondetails.length > 0
                        ? transactiondetails[0].ActionType
                          ? transactiondetails[0].ActionType +
                            "-" +
                            transactiondetails[0].FiscalYear +
                            "-" +
                            transactiondetails[0].InvoiceNr
                          : transactiondetails[0].InvoiceNr
                        : ""}
                    </b>
                  </label>
                </label>
                <label style={{ fontSize: "12px" }}>
                  <b>
                    {invoiceTranslate.invDate}:
                    {transactiondetails && transactiondetails.length > 0
                      ? transactiondetails[0].Date
                      : ""}
                  </b>
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.payDate}:{" "}
                  {transactiondetails && transactiondetails.length > 0
                    ? transactiondetails[0].PayDate
                    : ""}
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.user}:{" "}
                  {transactiondetails &&
                  transactiondetails.length > 0 &&
                  transactiondetails[0].CreatedByUser
                    ? transactiondetails[0].CreatedByUser.split("@")[0]
                    : ""}
                </label>
                <label style={{ fontSize: "12px" }}>
                  {invoiceTranslate.unit}
                </label>
              </div>
            </div>
            <hr style={{ margin: "10px" }}></hr>

            <div
              className="PrintContent__Container__div4"
              style={{
                padding: "10px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                {link && ( // Kontrolli nëse props.link nuk është null ose undefined
                  <QRCode
                    value={link}
                    style={{ width: "50px", height: "50px" }}
                  />
                )}
              </div>

              {/* Ketu duhet te vendoset barkodi */}
              <div>
                <svg ref={barcodeRef}></svg>
              </div>
            </div>
            <hr style={{ margin: "10px" }}></hr>

            <div
              className="PrintContent__Container__div5"
              style={{ margin: "10px", padding: "10px", height: "30px" }}
            >
              <div className="PrintContent__Container__div5__MainTable">
                <table
                  className="PrintTable"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <tbody>
                    <tr style={{ borderBottom: "1px solid black " }}>
                      <th
                        className="TableHeader"
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          border: "solid black 1px",
                          backgroundColor: "lightgray",
                          fontSize: "10px",
                          width: "120px",
                        }}
                      >
                        {invoiceTranslate.barcode}
                      </th>
                      <th
                        className="TableHeader"
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          border: "solid black 1px",
                          backgroundColor: "lightgray",
                          fontSize: "10px",
                          width: "300px",
                        }}
                      >
                        {invoiceTranslate.itemDesc}
                      </th>
                      <th
                        className="TableHeader"
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          border: "solid black 1px",
                          backgroundColor: "lightgray",
                          fontSize: "10px",
                          width: "90px",
                        }}
                      >
                        {invoiceTranslate.qty}
                      </th>
                      <th
                        className="TableHeader"
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          border: "solid black 1px",
                          backgroundColor: "lightgray",
                          fontSize: "10px",
                          width: "90px",
                        }}
                      >
                        {invoiceTranslate.artUnit}
                      </th>
                      {companiedDetails &&
                      companiedDetails.length > 0 &&
                      companiedDetails[0].VATDeclarant != 0 ? (
                        <>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.priceNoVAT}
                          </th>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.amountNoVAT}
                          </th>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.vatRates}
                          </th>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.rabat} %
                          </th>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.vat}
                          </th>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.priceWithVAT}
                          </th>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.amountWithVAT}
                          </th>
                        </>
                      ) : (
                        <>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.rabat} %
                          </th>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.price}
                          </th>
                          <th
                            className="TableHeader"
                            style={{
                              padding: "8px",
                              textAlign: "left",
                              border: "solid black 1px",
                              backgroundColor: "lightgray",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {invoiceTranslate.amount}
                          </th>
                        </>
                      )}
                    </tr>
                    {articleDetails &&
                      articleDetails.map((data, index) => (
                        <tr
                          style={{ borderBottom: "1px solid black " }}
                          key={index}
                        >
                          <td
                            style={{
                              padding: "3px",
                              textAlign: "left",
                              border: "1px solid black",
                              fontSize: "10px",
                              width: "120px",
                            }}
                          >
                            {data.Barcode}
                          </td>
                          <td
                            style={{
                              padding: "3px",
                              textAlign: "left",
                              border: "1px solid black",
                              fontSize: "10px",
                              width: "300px",
                            }}
                          >
                            {data.ArticleName}
                          </td>
                          {transactiondetails &&
                          transactiondetails.length > 0 &&
                          transactiondetails[0].ActionType !== "IND" ? (
                            <>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "left",
                                  border: "1px solid black",
                                  textAlign: "center",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.QtyInput}
                              </td>
                            </>
                          ) : (
                            <>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "left",
                                  border: "1px solid black",
                                  textAlign: "center",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.QtyOutput}
                              </td>
                            </>
                          )}
                          <td
                            style={{
                              padding: "3px",
                              textAlign: "left",
                              border: "1px solid black",
                              textAlign: "center",
                              fontSize: "10px",
                              width: "90px",
                            }}
                          >
                            {data.UnitName}
                          </td>
                          {companiedDetails &&
                          companiedDetails.length > 0 &&
                          companiedDetails[0].VATDeclarant != 0 ? (
                            <>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "right",
                                  border: "1px solid black",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.PriceWithoutVAT != null
                                  ? data.PriceWithoutVAT.toFixed(2)
                                  : ""}
                              </td>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "right",
                                  border: "1px solid black",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.Amount != null
                                  ? data.Amount.toFixed(2)
                                  : ""}
                              </td>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "right",
                                  border: "1px solid black",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.VATRates != null
                                  ? data.VATRates.toFixed(2)
                                  : ""}
                              </td>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "left",
                                  border: "1px solid black",
                                  textAlign: "center",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.DiscountPercent.toFixed(2)}
                              </td>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "right",
                                  border: "1px solid black",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.VAT != null ? data.VAT.toFixed(2) : ""}
                              </td>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "right",
                                  border: "1px solid black",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.PriceWithVAT != null
                                  ? data.PriceWithVAT.toFixed(2)
                                  : ""}
                              </td>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "right",
                                  border: "1px solid black",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.Total != null
                                  ? data.Total.toFixed(2)
                                  : ""}
                              </td>
                            </>
                          ) : (
                            <>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "left",
                                  border: "1px solid black",
                                  textAlign: "center",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.DiscountPercent.toFixed(2)}
                              </td>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "right",
                                  border: "1px solid black",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.PriceWithVAT != null
                                  ? data.PriceWithVAT.toFixed(2)
                                  : ""}
                              </td>
                              <td
                                style={{
                                  padding: "3px",
                                  textAlign: "right",
                                  border: "1px solid black",
                                  fontSize: "10px",
                                  width: "90px",
                                }}
                              >
                                {data.Total != null
                                  ? data.Total.toFixed(2)
                                  : ""}
                              </td>
                            </>
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <br></br>
              {companiedDetails &&
              companiedDetails.length > 0 &&
              companiedDetails[0].VATDeclarant != 0 ? (
                <div
                  className="PrintContent__Container__div5__SecondTable"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <table
                    className="PrintTable"
                    style={{ width: "40%", borderCollapse: "collapse" }}
                  >
                    <tbody>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <th
                          className="TableHeader"
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "solid black 1px",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                        >
                          {invoiceTranslate.normaTatimore}
                        </th>
                        <th
                          className="TableHeader"
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "solid black 1px",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                        >
                          {invoiceTranslate.base}
                        </th>
                        <th
                          className="TableHeader"
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "solid black 1px",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                        >
                          {invoiceTranslate.vat}
                        </th>
                        <th
                          className="TableHeader"
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "solid black 1px",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                            textAlign: "center",
                          }}
                        >
                          {invoiceTranslate.total}
                        </th>
                      </tr>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.tvshLlogaritur0}:
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {totalAmount0} €
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {(0).toFixed(2)} €
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {(Number(totalAmount0) + 0).toFixed(2)} €
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            fontSize: "10px",
                            width: "150px",
                          }}
                        >
                          {invoiceTranslate.tvshLlogaritur8}:
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {totalAmount8} €
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {vat8} €
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {(Number(totalAmount8) + Number(vat8)).toFixed(2)} €
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.tvshLlogaritur18}:
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {totalAmount18} €
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {vat18} €
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {(Number(totalAmount18) + Number(vat18)).toFixed(2)} €
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table
                    className="PrintTable"
                    style={{ width: "40%", borderCollapse: "collapse" }}
                  >
                    <tbody>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.vleraPaRabat}:
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {(
                            Number(totalAmount) + Number(amountPercent)
                          ).toFixed(2)}{" "}
                          €
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.rabat}:
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            textAlign: "right",
                            fontSize: "10px",
                          }}
                        >
                          {Number(amountPercent).toFixed(2)} €
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.totalNoVAT}:
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "right",
                            border: "1px solid black",
                            fontSize: "10px",
                          }}
                        >
                          {(
                            (Number(totalAmount0) || 0) +
                            (Number(totalAmount8) || 0) +
                            (Number(totalAmount18) || 0)
                          ).toFixed(2)}{" "}
                          €
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "left",
                            border: "1px solid black",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.totalVAT}:
                        </td>
                        <td
                          style={{
                            padding: "3px",
                            textAlign: "right",
                            border: "1px solid black",
                            fontSize: "10px",
                          }}
                        >
                          {((Number(vat8) || 0) + (Number(vat18) || 0)).toFixed(
                            2
                          )}{" "}
                          €
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "1px solid black " }}>
                        <th
                          className="TableHeader"
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            border: "solid black 1px",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.payment}:
                        </th>
                        <th
                          className="TableHeader"
                          style={{
                            padding: "8px",
                            textAlign: "right",
                            border: "solid black 1px",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                          }}
                        >
                          {(transactiondetails &&
                          transactiondetails.length > 0 &&
                          transactiondetails[0].Total != null
                            ? transactiondetails[0].Total
                            : 0
                          ).toFixed(2)}{" "}
                          €
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ) : (
                <table
                  className="PrintTable"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    borderCollapse: "collapse",
                  }}
                >
                  <tbody>
                    <tr style={{ borderBottom: "1px solid black " }}>
                      <th
                        className="TableHeader"
                        style={{
                          padding: "8px",
                          textAlign: "left",
                          border: "solid black 1px",
                          backgroundColor: "lightgray",
                          fontSize: "10px",
                        }}
                      >
                        {invoiceTranslate.payment}:
                      </th>
                      <th
                        className="TableHeader"
                        style={{
                          padding: "8px",
                          textAlign: "right",
                          border: "solid black 1px",
                          backgroundColor: "lightgray",
                          fontSize: "10px",
                        }}
                      >
                        {(transactiondetails &&
                        transactiondetails.length > 0 &&
                        transactiondetails[0].Total != null
                          ? transactiondetails[0].Total
                          : 0
                        ).toFixed(2)}{" "}
                        €
                      </th>
                    </tr>
                  </tbody>
                </table>
              )}

              <div
                className="PrintContent__Container__div6"
                style={{ marginTop: "20px" }}
              >
                {transactiondetails && transactiondetails.length > 0 ? (
                  transactiondetails[0].PaymentOptions === 0 ? (
                    <div>
                      <p style={{ fontSize: "12px" }}>
                        {invoiceTranslate.desc1}
                      </p>
                      {transactiondetails[0].Comment &&
                      transactiondetails[0].Comment != null ? (
                        <p style={{ fontSize: "12px" }}>
                          {invoiceTranslate.comment}:{" "}
                          {transactiondetails[0].Comment &&
                            transactiondetails[0].Comment}{" "}
                        </p>
                      ) : null}
                    </div>
                  ) : (
                    <div>
                      <p style={{ fontSize: "12px" }}>
                        {invoiceTranslate.desc2}
                      </p>
                      {transactiondetails[0].Comment &&
                      transactiondetails[0].Comment != null ? (
                        <p style={{ fontSize: "12px" }}>
                          {invoiceTranslate.comment}:{" "}
                          {transactiondetails[0].Comment &&
                            transactiondetails[0].Comment}{" "}
                        </p>
                      ) : null}
                    </div>
                  )
                ) : null}
              </div>
              <div style={{ paddingTop: "10px" }}>
                <div
                  className="PrintContent__Container__div7"
                  style={{ display: "flex", justifyContent: "space-evenly" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        border: "solid 1px blue",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                      }}
                    >
                      <label style={{ color: "blue", fontSize: "11px" }}>
                        {companiedDetails && companiedDetails.length > 0
                          ? companiedDetails[0].CompanyName
                          : ""}
                      </label>
                      <label style={{ color: "green", fontSize: "11px" }}>
                        {invoiceTranslate.confirm}
                      </label>
                      <label style={{ color: "blue", fontSize: "11px" }}>
                        {invoiceTranslate.vulaEl}
                      </label>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <label
                        style={{
                          color: "blue",
                          marginBottom: "-15px",
                          fontSize: "12px",
                        }}
                      >
                        {transactiondetails &&
                        transactiondetails.length > 0 &&
                        transactiondetails[0].CreatedByUser
                          ? transactiondetails[0].CreatedByUser.split("@")[0]
                          : ""}
                      </label>
                      <span>_________________________</span>
                      <label style={{ fontSize: "10px" }}>
                        {invoiceTranslate.faturoi}:
                      </label>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <label
                        style={{
                          color: "blue",
                          marginBottom: "-15px",
                          fontSize: "12px",
                        }}
                      >
                        {transactiondetails &&
                        transactiondetails.length > 0 &&
                        transactiondetails[0].CreatedByUser
                          ? transactiondetails[0].CreatedByUser.split("@")[0]
                          : ""}
                      </label>
                      <span>_________________________</span>
                      <label style={{ fontSize: "10px" }}>
                        {invoiceTranslate.dergoi}:
                      </label>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <span>_________________________</span>
                      <label style={{ fontSize: "10px" }}>
                        {invoiceTranslate.pranoi}:
                      </label>
                    </div>
                  </div>
                </div>

                <div
                  className="PrintContent__Container__div8"
                  style={{ margin: "10px", padding: "10px" }}
                >
                  <label style={{ width: "100%", fontSize: "10px" }}>
                    {invoiceTranslate.desc3}{" "}
                  </label>
                  <br></br>
                  <table
                    className="PrintTable"
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      borderTop: "1px solid black",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          borderBottom: "1px solid black ",
                          backgroundColor: "lightgray",
                        }}
                      >
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.bank}
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.accName}
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.accNumber}
                        </th>
                        <th
                          style={{
                            padding: "8px",
                            textAlign: "left",
                            backgroundColor: "lightgray",
                            fontSize: "10px",
                          }}
                        >
                          {invoiceTranslate.swift}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {banksdetails &&
                        banksdetails.map((data, index) => (
                          <tr
                            style={{
                              borderBottom: "1px solid black ",
                              fontSize: "10px",
                            }}
                            key={index}
                          >
                            <td
                              style={{
                                padding: "3px",
                                textAlign: "left",
                                fontSize: "10px",
                              }}
                            >
                              {data.AccountName}
                            </td>
                            <td
                              style={{
                                padding: "3px",
                                textAlign: "left",
                                fontSize: "10px",
                              }}
                            >
                              {companiedDetails &&
                              companiedDetails.length > 0 &&
                              companiedDetails[0].CompanyName
                                ? companiedDetails[0].CompanyName
                                : ""}
                            </td>
                            <td
                              style={{
                                padding: "3px",
                                textAlign: "left",
                                fontSize: "10px",
                              }}
                            >
                              {data.IBAN && data.IdentificationNumber
                                ? `${data.IBAN} ${data.IdentificationNumber}`
                                : ""}
                            </td>
                            <td
                              style={{
                                padding: "3px",
                                textAlign: "left",
                                fontSize: "10px",
                              }}
                            >
                              {data.SWIFT || ""}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
